import { z } from 'zod';

export const directionSchema = z.enum(['NORTH', 'SOUTH', 'EAST', 'WEST']);

export const roomTypeSchema = z.enum([
  'SAFE',
  'BOSS',
  'NORMAL_ENEMY',
  'ELITE_ENEMY',
  'TREASURE',
  'NPC',
  'TRAP',
  'SECRET',
  'TELEPORTER',
  'EMPTY',
]);

export const roomStatusSchema = z.enum(['UNEXPLORED', 'DISCOVERED', 'EXPLORED']);

export const consequenceSchema = z.object({
  healMpPercent: z.number().nonnegative().optional(),
  spendMana: z.number().nonnegative().optional(),
  damageHp: z.number().nonnegative().optional(),
  gainGold: z.number().int().optional(),
  loseGold: z.number().int().nonnegative().optional(),
  setCleared: z.boolean().optional(),
  triggerCombat: z.boolean().optional(),
  attemptFlee: z.boolean().optional(),
  enemyId: z.string().optional(),
  monsterName: z.string().optional(),
  bossName: z.string().optional(),
  learnSkillId: z.string().optional(),
  grantItemId: z.string().optional(),
  grantItemQty: z.number().int().positive().optional(),
  grantExp: z.number().int().nonnegative().optional(),
  retreatToPrevious: z.boolean().optional(),
  nextFloor: z.number().int().positive().optional(),
  message: z.string().min(1),
});

export const roomOptionSchema = z.object({
  id: z.string().min(1),
  action: z.string().min(1),
  actionText: z.string().min(1),
  buttonColor: z.string().optional(),
  consequence: consequenceSchema,
});

export const roomConnectionSchema = z.object({
  direction: directionSchema,
  targetRoomId: z.string().min(1),
  isLocked: z.boolean().optional(),
  isSecret: z.boolean().optional(),
});

export const floorRoomSchema = z.object({
  id: z.string().min(1),
  gridPos: z.object({ x: z.number().int(), y: z.number().int() }),
  type: roomTypeSchema,
  status: roomStatusSchema,
  name: z.string().min(1),
  description: z.string().min(1),
  safetyTag: z.string().min(1),
  bgImageKey: z.string().min(1),
  thumbnailKey: z.string().min(1).default('room_thumb'),
  isCleared: z.boolean(),
  isRequiredInteraction: z.boolean(),
  npcId: z.string().min(1).optional(),
  options: z.array(roomOptionSchema).default([]),
  connections: z.array(roomConnectionSchema),
});

export const floorFileSchema = z.object({
  floorNumber: z.number().int().positive(),
  floorName: z.string().min(1).default('Tầng Mê Cung'),
  gridWidth: z.number().int().positive(),
  gridHeight: z.number().int().positive(),
  objectiveText: z.string().min(1),
  root: z.object({ x: z.number().int(), y: z.number().int() }),
  safeRoomId: z.string().min(1),
  bossRoomId: z.string().min(1),
  teleporterRoomId: z.string().min(1),
  rooms: z.array(floorRoomSchema).min(1),
});

export type FloorFile = z.infer<typeof floorFileSchema>;
